import React from "react"

export const Pre = ({ data }) => (window.location.hostname === 'localhost'  || true )? <pre dangerouslySetInnerHTML={{ __html: JSON.stringify(data , null, 2) }}></pre> : <></>
